import Image from "next/image";
import Card from "@/components/UI/Card/Card";
import { PublicPageZip } from "@/utils/page";
import { JobGetResponse } from "@/types/job";
import Section from "@/components/Section/Section";
import SectionContainer from "@/components/Section/SectionContainer";
import SectionHeader from "@/components/Section/SectionHeader";
import Link from "@/components/UI/Link/Link";

interface Section20Props extends React.HTMLAttributes<HTMLElement> {
  job?: JobGetResponse;
  page: any;
  section: any;
}

const PostsSection = ({ className, job, page, section, ...props }: Section20Props) => {
  return (
    <Section section={section} {...props}>
      <SectionContainer className="lg:max-w-3xl" section={section}>
        <SectionHeader section={section} />
        {section?.Cards?.length > 0 && (
          <div className="flex flex-col gap-10">
            {section?.Cards?.map((card: any) => {
              return (
                <Link href={card.LinkUrl ?? ""} key={card?.id} variant="external">
                  <Card className="flex flex-1 divide-x rounded-md">
                    {card?.Image?.data?.attributes && (
                      <div className="flex-1">
                        <Image
                          alt={card?.Image?.data?.attributes?.alternativeText}
                          className="w-12 rounded-full"
                          src={card?.Image?.data?.attributes?.url}
                          width={card?.Image?.data?.attributes?.width ?? "100"}
                          height={card?.Image?.data?.attributes?.height ?? "100"}
                        />
                      </div>
                    )}
                    <div className="flex flex-1 flex-col gap-4 p-6">
                      {card?.Overline && <div className="text-lg text-vpGray-700">{card?.Overline}</div>}
                      {card?.Title && <div className="text-xl font-bold">{card?.Title}</div>}
                      {card?.Body && <div className="text-lg text-vpGray-700">{card?.Body}</div>}
                    </div>
                  </Card>
                </Link>
              );
            })}
          </div>
        )}
      </SectionContainer>
    </Section>
  );
};

export default PostsSection;
